import { CSSProperties } from "react";
import { colors } from "../../helpers/styles";
import { css } from "glamor";

export default function Description(props: {
  placeholder?: string;
  input: string;
  disabled?: boolean;
  customStyle?: CSSProperties;
  handleChange: (e: any) => void;
  handleAction?: {
    action: () => void;
    name: string;
  };
  name?: string;
  rows?: number;
  meta?: boolean;
  metaText?: string;
  label?: string;
}) {
  const {
    placeholder,
    input,
    disabled,
    customStyle,
    handleChange,
    handleAction,
    name,
    rows,
    meta,
    metaText,
    label,
  } = props;

  return (
    <div {...css({ float: "left" }, customStyle)}>
      {label && (
        <div
          {...css({
            float: "left",
            width: "100%",
            fontSize: 14,
            lineHeight: "17px",
            color: "rgba(0,0,0,0.54)",
            marginBottom: 6,
          })}
        >
          {label}
        </div>
      )}
      <div {...css({ float: "left", width: "100%" })}>
        <textarea
          disabled={disabled}
          placeholder={placeholder}
          {...css({
            width: "100%",
            boxSizing: "border-box",
            resize: "none",
            fontFamily: "Museo Sans",
            fontSize: "16px",
            fontWeight: "300",
            lineHeight: "19px",
            borderRadius: "3px",
            padding: "10px 12px",
            background: "#F9F9F9",
            border: 0,
          })}
          onKeyDown={(e) => {
            if (e.keyCode === 13 && !e.shiftKey && handleAction) {
              e.preventDefault();
              handleAction.action();
            }
          }}
          rows={rows}
          onChange={handleChange}
          name={name}
          value={input}
        />
      </div>
      <div
        {...css({
          float: "left",
          width: "100%",
          marginTop: "-24px",
          marginBottom: "6px",
        })}
      >
        {meta && (
          <div
            {...css({
              float: "left",
              fontSize: "10px",
              lineHeight: "28px",
              color: "rgba(0,0,0,0.54)",
              paddingTop: "6px",
            })}
          >
            **<b>bold</b>** *<i>italics</i>* ~~<strike>strike</strike>~~
          </div>
        )}
        {metaText && (
          <div
            {...css({
              float: "left",
              fontSize: "14px",
              fontWeight: "300",
              lineHeight: "normal",
              color: "rgba(0,0,0,0.54)",
              paddingTop: "6px",
              marginTop: 24,
            })}
          >
            {metaText}
          </div>
        )}
        {handleAction && (
          <div {...css({ float: "right" })}>
            {input ? (
              <button
                {...css({
                  background: colors.blue,
                  color: "white",
                  padding: "6px 8px",
                  fontSize: "14px",
                  lineHeight: "17px",
                  fontWeight: "500",
                  textAlign: "center",
                  borderRadius: "3px",
                  border: "0",
                  fontFamily: "Museo Sans",
                  cursor: "pointer",
                })}
                onClick={() => handleAction.action()}
              >
                {handleAction.name}
              </button>
            ) : (
              <button
                {...css({
                  background: colors.blue,
                  color: "white",
                  padding: "6px 8px",
                  fontSize: "14px",
                  lineHeight: "17px",
                  fontWeight: "500",
                  textAlign: "center",
                  borderRadius: "3px",
                  border: "0",
                  fontFamily: "Museo Sans",
                  opacity: "0.5",
                })}
                disabled
              >
                {handleAction.name}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
